import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Caption01, SingleLineEllipsis } from 'components/styles';

interface Props {
  primaryTitle: ReactNode;
  secondaryTitle?: ReactNode;
}

const PrimaryTitle = styled.div``;

const SecondaryTitle = styled.div`
  ${Caption01};
  ${SingleLineEllipsis};
  opacity: 0.5;
`;

export const ModalTitle: FC<Props> = ({ primaryTitle, secondaryTitle }) => {
  return (
    <>
      <PrimaryTitle>{primaryTitle}</PrimaryTitle>
      {secondaryTitle ? (
        <SecondaryTitle>{secondaryTitle}</SecondaryTitle>
      ) : null}
    </>
  );
};
